import { useEffect } from 'react';
import { loadModules, loadCss } from 'esri-loader';
import { DemoGraphicsApi } from '@apply/api';

/*
  Useful links from Mark
  https://developers.arcgis.com/documentation/mapping-apis-and-services/demographics/services/geoenrichment-service/
  https://developers.arcgis.com/documentation/mapping-apis-and-services/demographics/tools/data-collection-finder/
  https://developers.arcgis.com/arcgis-rest-js/demographic-data/query-demographic-data/
*/

const presentDemographics = async (location, view) => {
    try {
        view.popup.open({
            location: location,
            title: 'Loading...',
            content: null,
        });
        var data = await DemoGraphicsApi.getDemographicsTable(location);
        showData(location, view, data);
    } catch (ex) {
        view.popup.open({
            location: location,
            title: 'Error',
            content: 'We are sorry but we were unable obtain demographics for the selected area.',
        });
    }
};

const showData = (location, view, data) => {
    view.popup.open({
        location: location,
        title: 'Demographics',
        content: data,
    });
};

const Map = (mapRef) => {
    useEffect(() => {
        async function mapRefChanged() {
            let view;

            const initializeMap = async (mapRef) => {
                const modules = ['esri/Map', 'esri/views/MapView', 'esri/config', 'esri/widgets/Search', 'esri/rest/locator'];
                const [Map, MapView, Config, Search, locator] = await loadModules(modules);
                loadCss();
                const map = new Map({ basemap: 'arcgis-navigation' });
                Config.apiKey = DemoGraphicsApi.apiKey;
                view = new MapView({
                    map: map,
                    zoom: 4,
                    container: mapRef.current,
                    center: [-98.353, 38.449],
                    ui: {
                        components: ['attribution', 'zoom'],
                    },
                });

                const search = new Search({
                    view: view,
                });
                view.ui.add(search, 'top-left');

                search.on('select-result', (e) => {
                    presentDemographics(e.result.feature.geometry, view);
                });

                view.on('click', (e) => {
                    const params = {
                        location: e.mapPoint,
                        outFields: '*',
                    };
                    const locatorUrl = 'https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer';

                    locator.locationToAddress(locatorUrl, params).then(function (response) {
                        // Show the address found
                        presentDemographics(params.location, view);
                    });
                });
            };

            initializeMap(mapRef);

            return () => view?.destroy();
        }

        mapRefChanged();
    }, [mapRef]);
};

export default Map;
